/**
 * @module mOffice
 * @description mOffice application procides user interface for back-office users
 */

const COMPILED_LANGUAGES = 'sk'
const PREFERRED_COUNTRIES = 'SK,CZ,AT,HU,PL,DE,CH,UA,RO,MD,BG,RS,HR,SI'
global.LOGGER_WRAPPER = 'main'
require('../mele_elements')

function beforeStart(config) {
  require('./'+MOSY_APP+'.scss')

  const map_center = _.CONSTANTS.Soitron
  const start_module = 'mmodOfficeWfUnits'
  const menu_modules = [
    { label: 'office.administration', disabled: true },
    'mmodOfficeAdmin',
    'mmodOfficeWfDevices',
    'mmodOfficeWfUsers',
    'mmodOfficeWfApplications',
    'mmodOfficeWfUploads',
    'mmodOfficeWfClips',
    { label: 'office.master', disabled: true },
    'mmodOfficeWfConfigurations',
    'mmodOfficeWfEnrollments',
    'mmodOfficeWfZones',
    'mmodOfficeWfBuilds',
    { label: 'office.operation', disabled: true },
    'mmodOfficeNotifications',
    'mmodOfficeWfUnits',
    'mmodOfficeWfJobs',
    'mmodOfficeAlprsLive',
    'mmodOfficeAlprs',
    { label: 'office.registers', disabled: true },
    'mmodOfficeWiki',
    'mmodOfficeCallsigns',
    'mmodOfficeCertificates',
    { label: 'office.master', disabled: true },
    { label: 'office.integrations', disabled: true },
    'mmodOfficeAttachments',
    'mmodOfficeChats',
    'mmodOfficeIncidents',
    'mmodOfficeInstructions',
    'mmodOfficeShapes',
    'mmodOfficeWantedVehiclesAgendas',
    'mmodOfficeWantedVehicles',
  ]

  _.defaultsDeep(config, {
    mele_map: {
      center: map_center,
    },
    msysUser: {
      users_server: ':msvrUsers',
      zones_server: ':msvrZones',
      // auto_login: 'master',
      // auto_password: 'm',
      // auto_callsign: 'MAJSTER',
    },
    msysWM: {
      lang: 'sk',
      behavior: 'desktop',
      theme: 'day',
      styleset: 'new',
      start: start_module,
    },
    mmodAppBar: {
      modules: menu_modules,
      module_on_login: start_module,
      desktop: { type: 'dock', side: 'left', width: 200, order: 2 },
      languages: COMPILED_LANGUAGES.split(','),
      statusclick: 'logout',
    },
    mmodAppWall: {
      modules: menu_modules,
    },
    mmodEnroll: {
      auto_enroll: true,
    },
    mmodLogin: {
      login_format: '^[\\w-]+$',
      callsign_format: '',
    },
    msysProxy: {
      repos: {
        wiki: { fallbacks: [':'] },
        map_data: { fallbacks: [':'] },
        map_day: { fallbacks: ['https://tile.openstreetmap.org/{pathnoext}.png'], cache: false },
        map_night: { fallbacks: ['https://a.basemaps.cartocdn.com/dark_all/{pathnoext}.png'], cache: false },
      },
    },
  })
} // beforeStart

const LISTENERS = [
  // CORE SYSTEM
  require('msysLogger'),
  require('msysExec'),

  // CORE GUI
  require('msysWM'),
  require('mmodEmpty'),
  require('mmodSplash'),
  require('mmodAppBar'),
  require('mmodAppWall'),
  require('mmodAppLogo'),
  require('mmodNotifications'),
  // require('mmodOfficeImport'),

  // CLIENT/SERVER
  [require('msysLang'), 'msysLang', { prefixes: ['klady.'] }],
  require('msysProxy'),
  require('msysDomainClient'),
  require('mmodEnroll'),
  require('msysUser'),
  require('mmodLogin'),

  // ADMINISTRATION
  require('mmodOfficeAdmin'),
  [require('mmodWorkflow'), 'mmodOfficeWfBuilds', { workflow_server: ':msvrBuilds', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfUsers', { workflow_server: ':msvrUsers', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfApplications', { workflow_server: ':msvrApplications', tabular: true }],
  require('mmodOfficeWfDevices'),
  [require('mmodWorkflow'), 'mmodOfficeNotifications', { workflow_server: ':msvrNotifications', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfJobs', { workflow_server: ':msvrJobs', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfUploads', { workflow_server: ':msvrUploads', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfClips', { workflow_server: ':msvrClips', tabular: true }],
  [require('SK/mmodSkWiki'), 'mmodOfficeWiki', { workflow_server: ':msvrWiki' }],

  // OPERATION
  [require('mmodWorkflow'), 'mmodOfficeWfUnits', { workflow_server: ':msvrUnits', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeAlprsLive', { workflow_server: ':msvrWfAlpr', tabular: true, list_view: 'livetable', filter_view: 'livefilter' }],
  [require('mmodWorkflow'), 'mmodOfficeAlprs', { workflow_server: ':msvrWfAlpr', tabular: true }],

  // REGISTERS
  [require('mmodWorkflow'), 'mmodOfficeCallsigns', { workflow_server: ':msvrWfCallsigns', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeCertificates', { workflow_server: ':msvrWfCertificates', tabular: true }],

  // MASTER
  require('mmodOfficeWfConfigurations'),
  [require('mmodWorkflow'), 'mmodOfficeWfEnrollments', { workflow_server: ':msvrEnrollments', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfZones', { workflow_server: ':msvrZones', tabular: true }],

  // INTEGRATIONS
  [require('mmodWorkflow'), 'mmodOfficeAttachments', { workflow_server: ':msvrAttachments', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeChats', { workflow_server: ':msvrChats', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeIncidents', { workflow_server: ':msvrIncidents', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeInstructions', { workflow_server: ':msvrInstructions', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeShapes', { workflow_server: ':msvrShapes', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWantedVehiclesAgendas', { workflow_server: ':msvrWfWantedVehiclesAgendas', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWantedVehicles', { workflow_server: ':msvrWfWantedVehicles', tabular: true }],
] // LISTENERS

require('msysApplication')(LISTENERS, beforeStart)
